export interface IGrid {
  id?: number;
  name?: string;
  point1X?: number;
  point1Y?: number;
  point2X?: number;
  point2Y?: number;
  point3X?: number;
  point3Y?: number;
  point4X?: number;
  point4Y?: number;
  cellSize?: number;
  gridDimension?: number;
  dateCreated?: string | null;
}

export const defaultValue: Readonly<IGrid> = {};
